import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main.component";
import { AuthGuardMain } from "../auth/auth-guard.service";
import { PermissionGuard } from "../guards/permisson.guard";
import { SupportManageComponent } from "./support-manage/support-manage.component";

const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    canActivate: [AuthGuardMain],
    children: [
      { path: "", redirectTo: "/main/dashboard", pathMatch: "full" },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      // { path: 'analytic', loadChildren: () => import('./analytic/analytic.module').then(m => m.AnalyticModule)},
      // {
      //   path: 'password',
      //   loadChildren: () => import('../main/password/password.module').then(m => m.PasswordModule)
      // },
      {
        path: "user-management",
        canActivate: [PermissionGuard],
        data: { access: "users" },
        loadChildren: () =>
          import("../main/user-management/user-management.module").then(
            (m) => m.UserManagementModule
          ),
      },
      // {
      //   path: 'roles',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'roles' },
      //   loadChildren: () => import('../main/roles/roles.module').then(m => m.RolesModule)
      // },
      {
        path: "operator",
        canActivate: [PermissionGuard],
        data: { access: "operators" },
        loadChildren: () =>
          import("../main/operator/operator.module").then(
            (m) => m.OperatorModule
          ),
      },
      {
        path: "vehicle",
        canActivate: [PermissionGuard],
        data: { access: "vehicles" },
        loadChildren: () =>
          import("../main/vehicle/vehicle.module").then((m) => m.VehicleModule),
      },
      {
        path: "stop",
        loadChildren: () =>
          import("../main/manage-stop/manage-stop.module").then(
            (m) => m.BusStopModule
          ),
      },
      {
        path: "bus",
        loadChildren: () =>
          import("./bus-management/bus.module").then((m) => m.BusModule),
      },
      // {
      //   path: 'passenger',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'passengers' },
      //   loadChildren: () => import('../main/passenger/passenger.module').then(m => m.PassengerModule)
      // },
      // {
      //   path: 'payment-management',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'invoice' },
      //   loadChildren: () => import('../main/payment-management/payment-management.module').then(m => m.PaymentManagementModule)
      // },
      // {
      //   path: 'officer-management',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'EO' },
      //   loadChildren: () => import('../main/officer/officer.module').then(m => m.OfficerModule)
      // },

      {
        path: "driver-management",
        canActivate: [PermissionGuard],
        data: { access: "drivers" },
        loadChildren: () =>
          import("../main/driver-management/driver-management.module").then(
            (m) => m.DriverManagementModule
          ),
      },
      {
        path: "booking",
        loadChildren: () =>
          import("../main/booking-management/booking.module").then(
            (m) => m.BookingModule
          ),
      },

      // {
      //   path: 'reports-management',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'EO' },
      //   loadChildren: () => import('../main/report-management/report-management.module').then(m => m.ReportManagementModule)
      // },
      {
        path: "trips-management",
        canActivate: [PermissionGuard],
        data: { access: "trips" },
        loadChildren: () =>
          import("../main/trips-management/trips-management.module").then(
            (m) => m.TripsManagementModule
          ),
      },
      {
        path: "support-management",
        component: SupportManageComponent,
      },
      // {
      //   path: 'stakeholder',
      //    canActivate: [ PermissionGuard ],
      //    data: { access: 'stakeholders' },
      //   loadChildren: () => import('../main/stack-holder/shareholder.module').then(m => m.ShareholderModule)
      // },
      // {
      //   path: 'payout',
      //   loadChildren: () => import('../main/payout/payout.module').then(m => m.PayoutModule)
      // },
      // { path: 'covid',canActivate: [ PermissionGuard ],data: { access: 'covidTracker' }, loadChildren: () => import('../main/covid/covid.module').then(m => m.CovidModule)},
      // { path: 'terminal-management',canActivate: [ PermissionGuard ],data: { access: 'terminals' }, loadChildren: () => import('../main/terminal-management/terminal-management.module').then(m => m.TerminalManagementModule)},
      {
        path: "setting",
        loadChildren: () =>
          import("../main/setting-management/setting-management.module").then(
            (m) => m.SettingManagementModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
